export const BFZ_BFF = '/bfz-bff';

export const AFT_AIGC = '/aft-aigc';

export const AFT_CONTENT = '/afanti-content';

export const HJK = '/hjk';
